import { AxiosRequestConfig } from 'axios';
import { useMutation } from 'react-query';
import { axiosDefaultApi } from 'src/lib/axios'
import { MutationConfig} from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';

const header: AxiosRequestConfig = {responseType: "arraybuffer"}

const getBillingSummaryDownloadExcel = ( {data} : {data: IBillingSummarySearchForm}): Promise<string> => {
  return axiosDefaultApi.post(`api/Billing/ExportToExcel`, data, header);
};

type QueryFnType = typeof getBillingSummaryDownloadExcel;

type UseGetBillingSummaryDownloadExcelOptions = {
  data: IBillingSummarySearchForm;
  config?: MutationConfig<QueryFnType>;
};

export const useGetBillingSummaryDownloadExcel = ({ config }: UseGetBillingSummaryDownloadExcelOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();

  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στο κατέβασμα του αρχείου excel των χρεώσεων.`, 500);
      setIsNotificationVisible(true);
      console.error('An error occurred while downloading billing summary excel:', error);
    },
    onSuccess: () => {
      console.log('Billing summary report excel downloaded successfully.');
    },
    ...config,
    mutationFn: getBillingSummaryDownloadExcel,
  })
}